/**
 * Informations sur un tri.
 */
export class SortInfos {
	/**
	 * Informations sur un tri.
	 * @param columnName Nom de la propriété sur laquelle s'applique le tri.
	 * @param direction Sens du tri.
	 */
	constructor(
		public columnName: string = '',
		public direction: string = 'asc'
	) {}
}
